import React from 'react';

import { ZIndex } from '@rover/constants/src/styles/ZIndex';
import { Flex } from '@rover/kibble/core';
import { useTheme } from '@rover/kibble/themes';

import { OverlayProps } from './Overlay.common';

export type Props = OverlayProps;

const Overlay = (props: Props): JSX.Element => {
  const theme = useTheme();

  return (
    <Flex
      {...props}
      alignItems="center"
      sx={{
        backgroundColor: theme.background.overlay,
        ...props.sx,
      }}
      bottom="0"
      height="100%"
      justifyContent="center"
      left="0"
      padding="3x"
      position="fixed"
      right="0"
      top="0"
      width="100vw"
      zIndex={ZIndex.MODAL_OVERLAY.toString()}
    />
  );
};

export default Overlay;
